var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHotbarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.787109 7.43359H12.1204C12.4886 7.43359 12.7871 7.13512 12.7871 6.76693V2.10026C12.7871 1.73207 12.4886 1.43359 12.1204 1.43359H6.12044C5.75225 1.43359 5.45378 1.73207 5.45378 2.10026V5.43359M12.7871 3.43359H5.45378M1.45378 5.43359H9.45378C9.82197 5.43359 10.1204 5.73207 10.1204 6.10026V12.1003C10.1204 12.4684 9.82197 12.7669 9.45378 12.7669H1.45378C1.08559 12.7669 0.787109 12.4684 0.787109 12.1003V6.10026C0.787109 5.73207 1.08559 5.43359 1.45378 5.43359Z",
    stroke: "#123051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotbarIcon);
export default __webpack_public_path__ + "static/media/hotbarIcon.d020da238488ecf06c402c784d26672f.svg";
export { ForwardRef as ReactComponent };